import styled from '@emotion/styled';

import theme from '../../../styles/theme';
import { CartGridCell } from '../Cart.styles';

export const ColumnHeader = styled(CartGridCell)`
  background-color: ${theme.colors.whiteSecondary};
  font-weight: 600;
`;
